import { useContext } from "react";
import { HbrAddIcon, HbrAvatarProfile, HbrBulletinIcon, HbrEmoticonIcon, HbrMenuIcon, HbrMic } from "../newComponents/Mycustomsvgicons";
import { AuthContext } from "../AuthContext";
import { initDB, storeWallpaperSelected } from "../ConfigureIndexDB";
import { ChatContext } from "./ChatContextApi";
import UseLayout from "../newComponents/useLayout";

const ViewSelectedWallpaper = ({image, title, fromDevice,handleCloseView}) => {
    const {profile_pic} = useContext(AuthContext);
    const {userName} = useContext(AuthContext);
    const {handleSetWallpaper} = useContext(ChatContext);
    const {width} = UseLayout();

    const applyWallpaper =async()=>{
        if (fromDevice) {
            try {
                await initDB();
                await storeWallpaperSelected({
                    id: title,
                    image,
                    title
                });
                handleSetWallpaper(image, title);
                handleCloseView(true);
            } catch (error) {
                console.log(error)
            }
   

            // initDB().then(()=>{
            //     storeWallpaperSelected({
            //         id: title,
            //         image,
            //         title
            //     }).then(()=>{
            //         handleSetWallpaper(image, title);
            //         handleCloseView(true);
            //     }).catch((err)=>{
            //         console.log(err);
            //     });
            //    }).catch((err)=>{
             
            //    });
        }else{
            handleSetWallpaper(image, title);
            handleCloseView(true);
        }
    };


    return ( 
    <div className="viewselectedwallpaper">
        <h3 style={{color:"white"}}>{title}</h3>

        <div className="chatInfo">
            <span>Chat Room</span>

            {width > 700 && 
                <div className="flex-row2" style={{paddingTop:"15px"}}>
                    <HbrBulletinIcon width={"1.5em"} height={"1.5em"} fillColour={"teal"}/>
                    <h4 style={{color:"white"}}>{userName}</h4>
                </div>
            }
            
            <div className="top-icons">

                    <div style={{position:"relative"}}>
                        {profile_pic && profile_pic !== "" ? <img src={profile_pic} alt="User Profile"/>
                        :
                        <HbrAvatarProfile width={"2em"} height={"2em"}/>
                        }

                        <div style={{position: "absolute", top:"0px",left:"50%", backgroundColor:"#000000"}}>
                            <HbrMenuIcon width={"1.5em"} height={"1.5em"} fillColour={"#ffffff"}/>
                        </div>
                    </div>
            </div>
        </div>
      
       <div className="messages-collection">
              {image && <img id="imagetoapplyaswallpaper" src={image} alt="" />}  
       </div>

        <div className="input">
            <HbrEmoticonIcon width={"3em"} height={"3em"} fillColour={"#ffffff"}/>
    
            <textarea type="text" rows={4} disabled/>

            <div className="send">
                <HbrAddIcon width={"1.8em"} height={"1.8em"} fillColour={"#ffffff"}/>

                <div className="recordingmic">
                <HbrMic width={"2em"} height={"2em"} fillColour={"white"}/> 
                </div> 
        
            </div>

        </div>

        <button 
        onClick={()=>applyWallpaper()}
        style={{color:"white", 
            backgroundColor:"#eb268f",
            fontWeight:"bold", 
            cursor:"pointer",
             padding:"10px", 
             border:"none",
             borderRadius:"10px",
             }}
             >
            Apply
        </button>

    </div>
     );
}
export default ViewSelectedWallpaper;